import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Day } from 'src/app/Models/MisViajes/Day';
import { Month } from 'src/app/Models/MisViajes/months';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {
  $: any;
  slides: any;

  @Output()
  selectedDay = new EventEmitter<Day>();

  @Input()
  selectedMonth: Month;
  constructor() { }
  slideConfig = {
    dots: false,
    speed: 500,
    arrows: true,
    infinite: false,
    variableWidth: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 6,
    slidesToScroll: 5,
    cssEase: 'ease',
    focusOnSelect: false,
    centerMode: false
  };


  ngOnInit(): void {
    this.slides = [];
  }

  setSelectedDay(day: Day, clickedInput: MouseEvent): void {
    this.selectedDay.emit(day);
    this.setViewParams(day, clickedInput);
  }
  setViewParams(day: Day, clickedInput: MouseEvent) {
    clickedInput.preventDefault();
    $(".box-slider__item").removeClass('active');
    $(clickedInput.target).addClass('active');
  }
}
